var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48521 15.5148L3 21M15.8288 15.3761L17.517 13.6879C17.8992 13.3057 18.4176 13.091 18.958 13.091C20.7736 13.091 21.6828 10.896 20.399 9.61217L14.3878 3.60096C13.104 2.31718 10.9089 3.22641 10.9089 5.04196C10.9089 5.58243 10.6942 6.10078 10.3121 6.48295L8.62383 8.17118C8.24165 8.55335 7.72331 8.76806 7.18283 8.76806C5.36728 8.76806 4.45804 10.9631 5.74183 12.2469L11.7531 18.2581C13.0368 19.5419 15.2319 18.6327 15.2319 16.8171C15.2319 16.2767 15.4466 15.7583 15.8288 15.3761Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.b1a4b17180f17a26e8b18b3cebd08cca.svg";
export { ForwardRef as ReactComponent };